// VoalleSyncBadge — pílula discreta mostrando saúde do sync API Voalle.
// Tooltip no hover detalha métricas. Cor reflete saúde:
//   verde: última sync <60s + sem erros
//   amarelo: 60-180s ou poucos erros
//   vermelho: >180s sem rodar OU erro recente
//
// Não polui o dashboard — fica discreto no canto.

import { useEffect, useState } from 'react';
import { voalle } from '../lib/api.js';

export default function VoalleSyncBadge() {
  const [st, setSt] = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let alive = true;
    async function carregar() {
      try {
        const r = await voalle.status();
        if (alive) { setSt(r.data); setErro(false); }
      } catch (e) {
        if (alive) setErro(true);
      }
    }
    carregar();
    const h = setInterval(carregar, 30_000);
    return () => { alive = false; clearInterval(h); };
  }, []);

  if (erro) {
    return <span style={baseStyle('#fee2e2', '#991b1b')} title="Falha ao consultar status">
      ⚠ Voalle API: sem resposta
    </span>;
  }
  if (!st) return null;

  const u = st.ultima_sync;
  const ttlMin = st.token_cache?.ttl_seg != null ? Math.floor(st.token_cache.ttl_seg / 60) : null;

  let cor, bg, texto;
  if (!u) {
    cor = '#991b1b'; bg = '#fee2e2'; texto = 'Voalle API: aguardando 1ª sync';
  } else if (u.erros > 0) {
    cor = '#991b1b'; bg = '#fee2e2'; texto = `Voalle API: erro`;
  } else if (u.segundos_atras < 90) {
    cor = '#065f46'; bg = '#d1fae5'; texto = `Voalle: ${u.segundos_atras}s atrás`;
  } else if (u.segundos_atras < 180) {
    cor = '#92400e'; bg = '#fef3c7'; texto = `Voalle: ${u.segundos_atras}s atrás`;
  } else {
    cor = '#991b1b'; bg = '#fee2e2'; texto = `Voalle: ${Math.floor(u.segundos_atras / 60)}min atrás`;
  }

  const tooltip = u
    ? `Última: ${u.hora} · ${u.os_recebidas} OS recebidas · ${u.os_atualizadas} atualizadas\n` +
      `1h: ${st.agregado_1h?.execucoes_60min} execuções · ${st.agregado_1h?.atualizadas_60min} updates · ${st.agregado_1h?.erros_60min} erros\n` +
      `Token expira em ${ttlMin}min`
    : '';

  return (
    <span style={baseStyle(bg, cor)} title={tooltip}>
      <span style={{ width: 6, height: 6, borderRadius: 99, background: cor, display: 'inline-block' }} />
      {texto}
    </span>
  );
}

function baseStyle(bg, cor) {
  return {
    fontSize: 11, padding: '3px 8px', borderRadius: 99,
    background: bg, color: cor, fontWeight: 600,
    display: 'inline-flex', alignItems: 'center', gap: 6,
    border: `1px solid ${cor}33`,
    cursor: 'help',
  };
}
